import { Laverie } from "@/types";
import { getData, postData, putData, deleteData } from "./axios-service"
import { ContratStatus } from "@/types";

function modelMapper(inputLaverie: any): Laverie {
    return {
        id: inputLaverie.id,
        name: inputLaverie.name,
        dateDeDemarrage: inputLaverie.dateDeDemarrage,
        dateDeRenouvelement: inputLaverie.dateDeRenouvelement,
        numeroDeContrat: inputLaverie.numeroDeContrat,
        telephonePrincipal: inputLaverie.telephonePrincipal,
        telephoneAutre: inputLaverie.telephoneAutre,
        email: inputLaverie.email,
        website: inputLaverie.website,
        gestionnaire: inputLaverie.gestionnaire,
        codeAcces: inputLaverie.codeAcces,
        siret: inputLaverie.siret,
        tarifLavage: inputLaverie.tarifLavage,
        tarifSechage: inputLaverie.tarifSechage,
        tarifLessive: inputLaverie.tarifLessive,
        tauxDeRedevance: inputLaverie.tauxDeRedevance,
        dureeDuContrat: inputLaverie.dureeDuContrat,
        typeContrat: inputLaverie.typeContrat,
        periodicity: inputLaverie.periodicity,
        codeTournee: inputLaverie.codeTournee,
        contratStatus: inputLaverie.contratStatus,
        address: inputLaverie.address,
        accountId: inputLaverie.accountId,
        moyenDePaiement: inputLaverie.moyenDePaiement,
        tempsSechage: inputLaverie.tempsSechage,
        nbLaveLinge: inputLaverie.nbLaveLinge,
        nbSecheLinge: inputLaverie.nbSecheLinge,
        nbLaveLingeChauffant: inputLaverie.nbLaveLingeChauffant,
        nbLintTrap: inputLaverie.nbLintTrap,
        nbCondensateur: inputLaverie.nbCondensateur,
        nbPompeLessive: inputLaverie.nbPompeLessive,
        nbArmoireLessive: inputLaverie.nbArmoireLessive,
        nbStackedLave: inputLaverie.nbStackedLave,
        nbStackedSeche: inputLaverie.nbStackedSeche,
        nbCentrale: inputLaverie.nbCentrale,
        nbMonnayeur: inputLaverie.nbMonnayeur,
        nbBallonEauChaude: inputLaverie.nbBallonEauChaude,
        locationLaveLinge: inputLaverie.locationLaveLinge,
        locationSecheLinge: inputLaverie.locationSecheLinge,
        locationMonnayeur: inputLaverie.locationMonnayeur,
        locationArmoirePompeLessive: inputLaverie.locationArmoirePompeLessive,
        locationCentralePaiement: inputLaverie.locationCentralePaiement,
        seuil: inputLaverie.seuil,
        notificationEnabled: inputLaverie.notificationEnabled,
        priseDeContactType: inputLaverie.priseDeContactType,
        priseDeContactDate: inputLaverie.priseDeContactDate,
        previsiteDate: inputLaverie.previsiteDate,
        previsiteBy: inputLaverie.previsiteBy,
        previsitText: inputLaverie.previsitText,
        previsiteFileName: inputLaverie.previsiteFileName,
        dateSignatureContrat: inputLaverie.dateSignatureContrat,
        bonInstallationFileName: inputLaverie.bonInstallationFileName,
        installateur: inputLaverie.installateur,
        typePriseLL: inputLaverie.typePriseLL,
        typePriseSL: inputLaverie.typePriseSL,
        cleCaisse: inputLaverie.cleCaisse,
        cleDeProgrammation: inputLaverie.cleDeProgrammation,
        observationTechnique: inputLaverie.observationTechnique,
        verifTravaux: inputLaverie.verifTravaux,
        jetonLLType: inputLaverie.jetonLLType,
        jetonSLType: inputLaverie.jetonSLType,
        terminationDate: inputLaverie.terminationDate,
        fullAddress: inputLaverie.fullAddress,
    };
}

export function modelMapperArray(inputArray: any[]): Laverie[] {
    return inputArray.map(modelMapper);
}

export async function getAllLaveries(): Promise<Laverie[]> {
    const laveries = await getData<Laverie[]>("/laveries");
    return modelMapperArray(laveries ?? []);
}

export async function getFilteredLaveries(contractStatuses: ContratStatus[]): Promise<Laverie[]> {
    const laveries = await getData<Laverie[]>("/laveries?contract_status=" + contractStatuses.join(","));
    return modelMapperArray(laveries ?? []);
}
export async function getLaveriesByAccountId(accountId: string): Promise<Laverie[]> {
    const url = `/laveries?accountId=${accountId}`;
    const laveries = await getData<Laverie[]>(url);
    return modelMapperArray(laveries ?? []);
}

export function getLaverieById(id: string): Promise<Laverie> {
    return getData("/laveries/" + id).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export function postLaverie(laverie: Laverie): Promise<any> {
    return postData("/laveries", laverie).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export function putLaverie(laverie: Laverie): Promise<any> {
    return putData("/laveries/" + laverie.id, laverie);
}

export function addProductToLaverie(laverieId: string, productId: string): Promise<any> {
    const url = `/laveries/${laverieId}/add-product?productId=${productId}`;
    return putData(url);
}

export function removeProductFromLaverie(laverieId: string, productId: string): Promise<any> {
    const url = `/laveries/${laverieId}/remove-product?productId=${productId}`;
    return putData(url);
}

export function deleteLaverie(ids: string[]): Promise<any> {
    const idsStr = ids.join(',');
    return deleteData("/laveries/" + idsStr);
}